(function () {
  'use strict';

  /* @ngdoc object
   * @name rols.main
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main', [
      'ui.router',
      'itecAdministracio.rols.main.llista',
      'itecAdministracio.rols.main.submain.dades',
      'itecAdministracio.rols.main.submain.edit',
      'itecAdministracio.rols.main.submain.permisos'
    ]);
}());
